import { Button as AntdButton } from 'antd';
import { ButtonProps } from 'antd/es/button';
import styled from 'styled-components';

interface StyledButtonProps extends ButtonProps {
  variant?: 'primary' | 'secondary';
  outlined?: boolean;
}

const StyledButton = styled(AntdButton)<StyledButtonProps>`
  span {
    color: ${({ variant, theme, disabled, outlined }) =>
      outlined
        ? theme.colors.primary
        : variant === 'primary'
        ? disabled
          ? theme.colors.gray
          : 'white'
        : theme.colors.primary};
  }
  background-color: ${({ variant = 'primary', outlined, theme }) =>
    outlined
      ? 'white'
      : variant === 'primary'
      ? theme.colors.primary
      : theme.colors.sky};
`;

const Button = ({
  variant = 'primary',
  outlined = false,
  ...props
}: StyledButtonProps) => {
  return <StyledButton {...props} variant={variant} outlined={outlined} />;
};

export default Button;
